import React from 'react';
import { OtherSections, Remembers, Features } from '#components/organisms';
import { Layout } from '#hocs/layout';

const ReportsView = () => {
  return (
    <Layout section="reports">
      <Features />
      <Remembers section="reports" />
      <OtherSections />
    </Layout>
  );
};
export default ReportsView;
